import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Gtag, ConfigParams, CustomParams } from './gtag-definitions';

export interface GtagConfig {

  targetId: string; // gtag('config', 'targetId', configInfo )
  configInfo?: ConfigParams;
  setParams?: CustomParams; // gtag('set', setParams)
  moreIds?: string[];
}

export const GtagConfigToken = new InjectionToken<GtagConfig>('wizdm.gtag.config');

/** Reproduces the standard code snippet we would paste in index.html
 * @see: https://developers.google.com/analytics/devguides/collection/gtagjs */
export function gtagFactory(config: GtagConfig, http: HttpClient): Gtag {

  if ((window as any).gtag) { return (window as any).gtag; }

  console.log(config);

  let gtag: any;

  getConfig(http).subscribe(config => {

    const script = document.createElement('script');

    console.log(config);
    let domain = window.location.href.substr(window.location.href.indexOf('://') + 3);
    domain = domain.substr(0, domain.indexOf('/')).replace(':', '_').split('.').join('_');
    console.log(domain);

    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + config[domain].targetId;
    script.type = 'text/javascript';
    script.async = true;

    document.head.appendChild(script);

    (window as any).dataLayer = (window as any).dataLayer || [];
    // function gtag(...args){ (window as any).dataLayer.push(arguments);}
    gtag = function(...args) { (window as any).dataLayer.push(arguments); };

    gtag('js', new Date());

    gtag('config', config[domain].targetId, { send_page_view: true, ...config[domain].configInfo });

    ('setParams' in config[domain]) && gtag('set', config[domain].setParams );

    ('moreIds' in config[domain]) && config[domain].moreIds.forEach( id => gtag('config', id) );

    (window as any).gtag = gtag;

  });

  return (window as any).gtag = gtag;
  // return (window as any).gtag;
}

function getConfig(http: HttpClient) {

    return http.get(
      './assets/gtag-config.json'
    );
    // .toPromise()
    // .then((res: any) => {
    //   console.log(res);
    //   return res as GtagConfig;
    // });

}

//   getConfig(http).then(config => {

//     const script = document.createElement('script');

//     console.log(config);
//     let domain = window.location.href.substr(window.location.href.indexOf('://') + 3);
//     domain = domain.substr(0, domain.indexOf('/')).replace(':', '_').split('.').join('_');
//     console.log(domain);

//     script.src = 'https://www.googletagmanager.com/gtag/js?id=' + config[domain].targetId;
//     script.type = 'text/javascript';
//     script.async = true;

//     document.head.appendChild(script);

//     (window as any).dataLayer = (window as any).dataLayer || [];
//     // function gtag(...args){ (window as any).dataLayer.push(arguments);}
//     gtag = function(...args) { (window as any).dataLayer.push(arguments);}

//     gtag('js', new Date());

//     gtag('config', config[domain].targetId, { send_page_view: true, ...config[domain].configInfo });

//     ('setParams' in config[domain]) && gtag('set', config[domain].setParams );

//     ('moreIds' in config[domain]) && config[domain].moreIds.forEach( id => gtag('config', id) );
//     (window as any).gtag = gtag;

//   });

//   return (window as any).gtag = gtag;
//   // return (window as any).gtag;
// }

// async function getConfig(http: HttpClient) {

//     return http.get(
//       './assets/gtag-config.json'
//     )
//     .toPromise()
//     .then((res: any) => {
//       console.log(res);
//       return res as GtagConfig;
//     });

// }
